module.exports = __webpack_public_path__ + "img/08刘凯松.e4dfe10a.jpg";